import React from 'react'

const UserAvatar = ({size = '48px', image = '/images/khub_anwar.jpg'}) => {
  return (
    <div
      style={{width: size, height: size, backgroundImage: `url('${image}')`}}
      className="bg-no-repeat bg-center bg-cover rounded rounded-full"
    />
  )
}

export { UserAvatar }